import { alertFailure, errorText, ShownError } from "../../utils/error-messages";

export const initDocumentDelete = () => {
  const documentForms = document.querySelectorAll(".document-form");

  documentForms.forEach((documentForm) => {
    const buttonDelete = documentForm.querySelector(".button-delete") as HTMLButtonElement;

    buttonDelete.addEventListener(
      "click",
      () => {
        const userId = buttonDelete.dataset.userId;
        const documentId = buttonDelete.dataset.documentId;
        const documentAdd = documentForm.querySelector(".document-add") as HTMLDivElement;
        const documentInReview = documentForm.querySelector(
          ".document-in-review",
        ) as HTMLDivElement;

        const spinner = buttonDelete.querySelector(".spinner") as HTMLDivElement;
        spinner.classList.remove("d-none");

        fetch(`/website-api/users/${userId}/documents/${documentId}/`, {
          credentials: "same-origin",
          method: "delete",
        })
          .then((response) => {
            if (response.status === 401) {
              throw new Error("Unauthorized");
            }
            if (response.status === 429) {
              throw new ShownError(errorText("rateLimited"));
            }
            if (response.status === 500) {
              throw new Error("Service is unavailable");
            }

            return response.json();
          })
          .then((jsonResponse) => {
            if (jsonResponse.metadata.code >= 400) {
              if (jsonResponse.metadata.errors) {
                alert(jsonResponse.metadata.errors[0].error);

                return;
              }

              if (jsonResponse.metadata.error_message) {
                alert(jsonResponse.metadata.error_message);

                return;
              }

              alert(errorText("generic"));

              return;
            }

            documentAdd.style.display = "block";
            documentInReview.style.display = "none";

            // Swap the footer back on the single-document page once the document is removed: hide
            // "Done" and restore a reset "Continue" button (visible, disabled, no file selected).
            const documentDone = document.querySelector(".document-done") as HTMLElement | null;
            if (documentDone) {
              documentDone.style.display = "none";
            }

            const submitButton = document.querySelector(
              ".document-submit",
            ) as HTMLButtonElement | null;
            if (submitButton) {
              submitButton.style.display = "block";
              submitButton.disabled = true;
            }

            // Reset the add screen back to the empty drop zone (hide the selected-file card).
            const documentSelect = documentForm.querySelector(
              ".document-select",
            ) as HTMLDivElement | null;
            documentSelect?.classList.remove("d-none");

            const documentFile = documentForm.querySelector(
              ".document-file",
            ) as HTMLDivElement | null;
            documentFile?.classList.add("d-none");

            const documentInput = documentForm.querySelector(
              ".document-input",
            ) as HTMLInputElement | null;
            if (documentInput) {
              documentInput.value = "";
            }

            spinner.classList.add("d-none");
          })
          .catch((error) => {
            spinner.classList.add("d-none");
            alertFailure(error);
          });
      },
      false,
    );
  });
};
